import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Box, Button, Stepper, Step, StepLabel, Paper } from "@mui/material";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  getUserByAddress,
  UploadUserdocs,
  UserKyc,
  VerifyOTP,
} from "../../../hooks/User";
import PreviewStep from "./KycSteps/PreviewStep";

const MultiStepForm = () => {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const Address = localStorage.getItem("WalletAddress");
  const [documents, setDocuments] = useState(
    formData.documents || [
      { type: "", number: "", frontImage: null, backImage: null },
    ]
  );

  const validateStep = () => {
    let newErrors = {};
    if (activeStep === 0) {
      if (!formData.firstName) newErrors.firstName = "First name is required";
      if (!formData.lastName) newErrors.lastName = "Last name is required";
      if (!formData.username) newErrors.username = "Username is required";
      if (!formData.email) newErrors.email = "Email is required";
    } else if (activeStep === 1) {
      if (!formData.country) newErrors.country = "Country is required";
      if (!formData.state) newErrors.state = "State is required";
      if (!formData.city) newErrors.city = "City is required";
      if (!formData.locality) newErrors.city = "Locality is required";
      if (!formData.postalCode)
        newErrors.postalCode = "Postal code is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = (e) => {
    e.preventDefault();
    if (validateStep()) {
      if (activeStep === 3) {
        handleSubmit(e);
      }
      if (activeStep === 2) {
        upgradeLocalToAWSFile();
        setActiveStep((prev) => prev + 1);
      } else {
        setActiveStep((prev) => prev + 1);
      }
    }
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const handleChange = (e) => {
    e.preventDefault();
    setFormData({ ...formData, [e.target.name]: e.target.value });
    validateStep();
  };

  const verifyOTP = async () => {
    setIsSubmitting(true);
    if (formData.otp) {
      const body = {
        email: formData.email,
        otp: formData.otp,
      };

      const response = await VerifyOTP(body);
      console.log("res", response);

      setTimeout(() => {
        toast.success("OTP verified successfully!");
        navigate("/profile");
        setIsSubmitting(false);
      }, 2000);
    } else {
      alert("Invalid OTP! Please try again.");
    }
  };

  const resendOTP = async () => {
    setIsSubmitting(true);
    setTimeout(() => {
      toast.success("OTP resent successfully!");
      setIsSubmitting(false);
    }, 2000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const submitObj = {
        walletAddress: Address,
        address: {
          country: formData.country,
          state: formData.state,
          city: formData.city,
          address: formData.locality,
          pincode: formData.postalCode,
        },
        fName: formData.firstName,
        lName: formData.lastName,
        username: formData.username,
        email: formData.email,
        bio: formData.bio,
        userPicture: formData.userProfile,
        idProofs: documents,
      };
      console.log("formDataToSend", submitObj);
      const response = await UserKyc(submitObj);
      console.log("Form submitted successfully:", response, response.data);
      // setActiveStep(prev => prev + 1);
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to submit the form. Please try again later.");
    }
  };

//   const renderStep = () => {
//     switch (activeStep) {
//       case 0:
//         return (
//           <BasicDetailsStep
//             formData={formData}
//             handleChange={handleChange}
//             handleNext={handleNext}
//             errors={errors}
//           />
//         );
//       case 1:
//         return (
//           <AddressStep
//             formData={formData}
//             handleChange={handleChange}
//             handleNext={handleNext}
//             handleBack={handleBack}
//             errors={errors}
//           />
//         );
//       case 2:
//         return (
//           <DocumentsStep
//             documents={documents}
//             setDocuments={setDocuments}
//             handleNext={handleNext}
//             handleBack={handleBack}
//           />
//         );
//       case 3:
//         return (
//           <PreviewStep
//             formData={formData}
//             documents={documents}
//             prevStep={handleBack}
//           />
//         );
//       case 4:
//         return (
//           <OTPVerificationStep
//             formData={formData}
//             verifyOTP={verifyOTP}
//             resendOTP={resendOTP}
//             handleBack={handleBack}
//             isSubmitting={isSubmitting}
//           />
//         );
//       default:
//         return null;
//     }
//   };

  const steps = [
    "Basic Details",
    "Address",
    "Upload Documents",
    "Preview",
    "OTP Verification",
  ];

  useEffect(() => {
    getUserByAddress(Address).then((data) => {
      if (data.status === 200) {
        setFormData((prev) => ({ ...prev, ...data.user }));
      }
    });
  }, [Address]);

  const [previewImage, setPreviewImage] = useState(null);

  const handleFileChange = async (event, field) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file size and type
      if (file.size > 5 * 1024 * 1024) {
        toast.error("File size should not exceed 5MB");
        return;
      }
      if (!file.type.match("image.*")) {
        toast.error("Please select an image file");
        return;
      }

      // Create preview URL
      const previewURL = URL.createObjectURL(file);
      setPreviewImage(previewURL);

      try {
        // Handle file upload logic here
        const body = { userPicture: file };
        const response = await UploadUserdocs(formData._id, body);
        setFormData((prev) => ({ ...prev, [field]: file }));
        setFormData((prev) => ({ ...prev, userProfile: response.userPicture }));
        toast.success("Profile picture uploaded successfully");
      } catch (error) {
        toast.error("Failed to upload profile picture");
        console.error("Upload error:", error);
      }
    }
  };

  console.log("formData Step 1", formData, formData._id, activeStep, documents);
  const Ser = new FormData();
  const handledocFileChange = (e, index, type) => {
    const file = e.target.files[0];
    const newDocuments = [...documents];
    newDocuments[index][type] = file;
    Ser.append("image", file);
    setDocuments(newDocuments);
  };

  useEffect(() => {
    return () => {
      // Cleanup preview URL when component unmounts
      if (previewImage) {
        URL.revokeObjectURL(previewImage);
      }
    };
  }, [previewImage]);

  const handleInputChange = (e, index, field) => {
    const value = e.target.value;
    const newDocuments = [...documents];
    newDocuments[index][field] = value;
    setDocuments(newDocuments);
  };

  const handleAddDocument = () => {
    setDocuments([
      ...documents,
      { type: "", documentDetail: "", frontImage: null, backImage: null },
    ]);
  };

  const renderImageUploadFields = (docType, index) => {
    switch (docType) {
      case "Aadhar":
      case "Driver's License":
      case "Voter ID":
        return (
          <>
            <Form.Group>
              <p className="mt-3">Front Image</p>
              <Form.Control
                type="file"
                accept=".jpg, .png, .pdf"
                onChange={(e) => handledocFileChange(e, index, "frontImage")}
                required
              />
            </Form.Group>
            <Form.Group>
              <p className="mt-3">Back Image</p>
              <Form.Control
                type="file"
                accept=".jpg, .png, .pdf"
                onChange={(e) => handledocFileChange(e, index, "backImage")}
                required
              />
            </Form.Group>
          </>
        );
      case "Passport":
      case "Pan Card":
        return (
          <Form.Group>
            <p className="mt-3">Front Image</p>
            <Form.Control
              type="file"
              accept=".jpg, .png, .pdf"
              onChange={(e) => handledocFileChange(e, index, "frontImage")}
              required
            />
          </Form.Group>
        );
      default:
        return null;
    }
  };
  // convert local to aws file for user profile and documents
  const upgradeLocalToAWSFile = async () => {
    console.log("Documents at API calling", documents);

    try {
      // Use Promise.all to handle multiple async calls inside map
      const updatedDocs = await Promise.all(
        documents.map(async (doc, index) => {
          let updatedDoc = { ...doc };

          if (doc.frontImage) {
            const body = { idProofs: doc.frontImage };
            const response = await UploadUserdocs(formData._id, body);
            updatedDoc.frontImage = response.idProofs[0]?.proofs;
          }

          if (doc.backImage) {
            const body = { idProofs: doc.backImage };
            const response = await UploadUserdocs(formData._id, body);
            updatedDoc.backImage = response.idProofs[0]?.proofs;
          }

          return updatedDoc;
        })
      );

      // Update the state once after all documents are processed
      setDocuments(updatedDocs);

      console.log("Updated Docs:", updatedDocs);
    } catch (error) {
      console.error("Error uploading docs:", error);
    }
  };

  console.log("docs at idProofs Add", documents);

  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return (
          <Form className="space-y-4">
            <div className="d-flex gap-4">
              <Form.Group className="flex-grow-1">
                <p>First Name</p>
                <Form.Control
                  type="text"
                  name="firstName"
                  // {...register('firstName')}
                  defaultValue={formData.firstName || ""}
                  isInvalid={!!errors.firstName}
                  onChange={(e) => handleChange(e)}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.firstName}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="flex-grow-1">
                <p>Last Name</p>
                <Form.Control
                  type="text"
                  // {...register('lastName')}
                  name="lastName"
                  defaultValue={formData.lastName || ""}
                  isInvalid={!!errors.lastName}
                  onChange={(e) => handleChange(e)}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.lastName}
                </Form.Control.Feedback>
              </Form.Group>
            </div>

            <div className="d-flex gap-4">
              <Form.Group className="flex-grow-1">
                <p>Username</p>
                <Form.Control
                  type="text"
                  name="username"
                  onChange={(e) => handleChange(e)}
                  // {...register('username')}
                  defaultValue={formData.username || ""}
                  isInvalid={!!errors.username}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.username}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="flex-grow-1">
                <p>Email</p>
                <Form.Control
                  type="email"
                  name="email"
                  onChange={(e) => handleChange(e)}
                  // {...register('email')}
                  defaultValue={formData.email || ""}
                  isInvalid={!!errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </div>

            <div className="d-flex gap-4">
              <Form.Group className="flex-grow-1">
                <p>Wallet Address</p>
                <Form.Control
                  type="text"
                  // {...register('walletAddress')}
                  defaultValue={Address}
                  value={Address}
                  disabled
                  // isInvalid={!!errors.walletAddress}
                />
                {/* <Form.Control.Feedback type="invalid">
                {errors.walletAddress?.message}
              </Form.Control.Feedback> */}
              </Form.Group>
            </div>

            <Form.Group>
              <p>Bio</p>
              <Form.Control
                onChange={(e) => handleChange(e)}
                as="textarea"
                name="bio"
                rows={4}
                //   {...register('bio')}
                defaultValue={formData.bio || ""}
                //   isInvalid={!!errors.bio}
              />
              {/* <Form.Control.Feedback type="invalid">
              {errors.bio?.message}
            </Form.Control.Feedback> */}
            </Form.Group>

            <Form.Group>
              <p>Profile Image</p>
              <Form.Control
                type="file"
                accept="image/*"
                onChange={(e) => handleFileChange(e, "profileImage")}
              />
              {previewImage && (
                <div className="mt-3 text-center">
                  <img
                    src={previewImage}
                    alt="Profile Preview"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "cover",
                      borderRadius: "10px",
                      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    }}
                  />
                </div>
              )}
            </Form.Group>
          </Form>
        );

      case 1:
        return (
          <Form className="space-y-4">
            <div className="d-flex gap-4">
              <Form.Group className="flex-grow-1">
                <p>Country</p>
                <Form.Control
                  type="text"
                  placeholder="Country"
                  //   {...register('country')}
                  defaultValue={formData.country || ""}
                  onChange={(e) => handleChange(e)}
                  name="country"
                  isInvalid={!!errors.country}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.country}
                </Form.Control.Feedback>
              </Form.Group>
            </div>
            <div className="d-flex gap-4">
              <Form.Group className="flex-grow-1">
                <p>State</p>
                <Form.Control
                  type="text"
                  // {...register('state')}
                  placeholder="State"
                  defaultValue={formData.state || ""}
                  onChange={(e) => handleChange(e)}
                  name="state"
                  isInvalid={!!errors.state}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.state}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group className="flex-grow-1">
                <p>City</p>
                <Form.Control
                  type="text"
                  // {...register('city')}
                  placeholder="City"
                  defaultValue={formData.city || ""}
                  isInvalid={!!errors.city}
                  onChange={(e) => handleChange(e)}
                  name="city"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.city}
                </Form.Control.Feedback>
              </Form.Group>
            </div>
            <div className="d-flex gap-4">
              <Form.Group className="flex-grow-1">
                <p>Locality</p>
                <Form.Control
                  type="text"
                  placeholder="Locality"
                  // {...register('locality')}
                  defaultValue={formData.locality || ""}
                  isInvalid={!!errors.locality}
                  onChange={(e) => handleChange(e)}
                  name="locality"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.locality}
                </Form.Control.Feedback>
              </Form.Group>
            </div>
            <div className="d-flex gap-4">
              <Form.Group className="flex-grow-1">
                <p>Postal code</p>
                <Form.Control
                  type="text"
                  // {...register('postalCode')}
                  placeholder="Postal Code"
                  defaultValue={formData.postalCode || ""}
                  isInvalid={!!errors.postalCode}
                  onChange={(e) => handleChange(e)}
                  name="postalCode"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.postalCode}
                </Form.Control.Feedback>
              </Form.Group>
            </div>
          </Form>
        );
      //   import { Form, Button } from 'react-bootstrap';

      case 2:
        return (
          // <Form className="space-y-4">
          //     <Form.Group controlId="documentType">
          //         <p>Document Type</p>
          //         <Form.Control
          //             as="select"
          //             // {...register('documentType')}
          //             isInvalid={!!errors.documentType}
          //         >
          //             <option value="">Select Document Type</option>
          //             <option value="passport">Passport</option>
          //             <option value="aadharCard">Aadhar Card</option>
          //             <option value="driverLicense">Driver's License</option>
          //             <option value="voterId">Voter ID</option>
          //             <option value="panCard">Pan Card</option>
          //         </Form.Control>
          //         <Form.Control.Feedback type="invalid">
          //             {errors.documentType?.message}
          //         </Form.Control.Feedback>
          //     </Form.Group>

          //     <Form.Group controlId="documentNumber">
          //         <p>Document Number</p>
          //         <Form.Control
          //             type="text"
          //             // {...register('documentNumber')}
          //             isInvalid={!!errors.documentNumber}
          //         />
          //         <Form.Control.Feedback type="invalid">
          //             {errors.documentNumber?.message}
          //         </Form.Control.Feedback>
          //     </Form.Group>

          //     <Form.Group controlId="frontImage">
          //         <p>Front Image</p>
          //         <Form.Control
          //             type="file"
          //             accept="image/*"
          //             onChange={e => handleFileChange(e, 'frontImage')}
          //             isInvalid={!!errors.frontImage}
          //         />
          //         <Form.Control.Feedback type="invalid">
          //             {errors.frontImage?.message}
          //         </Form.Control.Feedback>
          //     </Form.Group>

          //     {['aadharCard', 'driverLicense', 'voterId'].includes('documentType') && (
          //         <Form.Group controlId="backImage">
          //             <p>Back Image</p>
          //             <Form.Control
          //                 type="file"
          //                 accept="image/*"
          //                 onChange={e => handleFileChange(e, 'backImage')}
          //                 isInvalid={!!errors.backImage}
          //             />
          //             <Form.Control.Feedback type="invalid">
          //                 {errors.backImage?.message}
          //             </Form.Control.Feedback>
          //         </Form.Group>
          //     )}
          // </Form>
          <Form className="box mt-4" onSubmit={handleSubmit}>
            <h3>Step 3: Upload Documents</h3>

            {documents.map((doc, index) => (
              <div key={index} className="mb-3">
                <h5>Document {index + 1}</h5>
                <Form.Group>
                  <p className="mt-3">Document Type</p>
                  <Form.Control
                    as="select"
                    value={doc.type}
                    onChange={(e) => handleInputChange(e, index, "type")}
                    required
                  >
                    <option value="">Select Document Type</option>
                    <option value="Passport">Passport</option>
                    <option value="Aadhar">Aadhar</option>
                    <option value="Driver's License">Driver's License</option>
                    <option value="Voter ID">Voter ID</option>
                    <option value="Pan Card">Pan Card</option>
                  </Form.Control>
                </Form.Group>

                <Form.Group>
                  <p className="mt-3">Document Number</p>
                  <Form.Control
                    type="text"
                    value={doc.documentDetail}
                    onChange={(e) =>
                      handleInputChange(e, index, "documentDetail")
                    }
                    required
                  />
                </Form.Group>

                {renderImageUploadFields(doc.type, index)}
              </div>
            ))}

            <div className="d-flex justify-content-between mt-3">
              <Button variant="link btn-grad" onClick={handleAddDocument}>
                Add Another Document
              </Button>
              {/* <Button variant="secondary" onClick={prevStep}> */}
              {/* Back */}
              {/* </Button> */}
              {/* <Button variant="contained" onClick={upgradeLocalToAWSFile}>
                                Submit
                            </Button> */}
            </div>
          </Form>
        );

      case 3:
        return (
          <div className="space-y-4">
            <h2 className="text-xl font-semibold">Review Your Information</h2>
            <div className="grid grid-cols-2 gap-4">
              {Object.entries(formData).map(([key, value]) => (
                <div key={key}>
                  <strong className="capitalize">{key}:</strong>{" "}
                  {value instanceof File ? value.name : String(value)}
                </div>
              ))}
            </div>
          </div>
        );

      case 4:
        return (
          <Form className="space-y-4">
            <Form.Group>
              <p>Enter OTP</p>
              <Form.Control
                type="text"
                //   {...register('otp')}
                name="otp"
                defaultValue={formData.otp || ""}
                isInvalid={!!errors.otp}
                onChange={(e) => handleChange(e)}
              />
              <Form.Control.Feedback type="invalid">
                {errors.otp?.message}
              </Form.Control.Feedback>
            </Form.Group>
            <Button
              onClick={resendOTP}
              disabled={isSubmitting}
              className="mt-4"
            >
              Resend OTP
            </Button>
          </Form>
        );

      default:
        return null;
    }
  };

  console.log("formData", formData);

  return (
    <div className="container">
      <Link to="/launchpad" className="btn btn-white btn-sm my-40">
        back to LaunchPad
      </Link>
      <Paper sx={{ p: 3 }}>
        <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <form>
          {renderStepContent()}

          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
            <Button disabled={activeStep === 0} onClick={handleBack}>
              Back
            </Button>
            <Button
              type="submit"
              variant="contained"
              disabled={isSubmitting}
              onClick={(e) => (activeStep === 4 ? verifyOTP(e) : handleNext(e))}
            >
              {activeStep === steps.length - 1 ? "Verify" : "Next"}
            </Button>
          </Box>
        </form>
      </Paper>
    </div>
  );
};

export default MultiStepForm;
